export default __webpack_public_path__ + "static/media/bat3.54240d09.jpg";